



























import Vue from 'vue';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import { cleanedFileName } from '@/core/utils/utils';
export default Vue.extend({
  name: 'QuizUploadFile',
  props: {
    value: {
      required: true,
      type: Array,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    addFile(file) {
      const files = [...this.value];
      files.push(file);
      console.log(files);
      this.$emit('input', files);
    },
    removeFile(fileIndex) {
      const files = [...this.value];
      files.splice(fileIndex, 1);
      this.$emit('input', files);
    },
    getStudioURL() {
      return getStudioURL(this.$route);
    },
    cleanedFileName,
  },
});
